
import './style.css'
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import PanelLayout from '../../panelComponents/PanelLayout/PanelLayout';
import authService from '../../../service/auth';
import { List, ListBody, ListFilterButtons, ListRowActions, ListWrapper, TaxReturnStatus } from '../../../BTUI/List';
import { useDispatch, useSelector } from 'react-redux';
import { setTaxfileFilter } from '../../../store/userSlice';
import { STATUS_COLOR } from '../../../utils/constants';
import { hideLoader, showLoader } from '../../../BTUI/BtLoader';

const TaxFileList = () => {


    const [taxFileList, setTaxFileList] = useState(null);
    const [clientMessage, setClientMessage] = useState([]);
    const [taxfileStatus, setTaxfileStatus] = useState([]);
    const navigate = useNavigate()

    const {taxfileFilter=[],user} = useSelector(store=>store?.user)
    const dispatch =useDispatch()


    const fetchList=()=>{
        showLoader()
        authService?.taxfilesList({queryParams:{
            tax_file_status:taxfileFilter?.join() || []
        }})
            .then((res) =>{
                setTaxFileList(res?.data?.response?.taxfiles)
                // hideLoader()
            })
            .catch((err) => {
                console.log(err)
                // hideLoader()
            })
            .finally(()=>hideLoader())
    }

    useEffect(()=>{
        fetchList()
    },[taxfileFilter])

    useEffect(()=>{
            authService.dashUserMsgListCount()
            .then(res => {
                setClientMessage(res?.data?.response?.list)
            })
            .catch(err => {
                console.log('Error in Get Client Messages', err)
            })

            authService.getTaxfileStatus()
            .then((res) => {
                setTaxfileStatus(res?.data?.response?.taxfileStatusList?.map(itm=>{
                    return {
                        value:itm?.code,
                        title:itm?.name,
                        bgColor: STATUS_COLOR?.[itm?.code]?.bgColor,
                        textColor: STATUS_COLOR?.[itm?.code]?.color,
                    }
                }))
            })
            .catch((err) => {
                // console.log(err)
            });
    },[])


    return<PanelLayout>
        <div className="dashList-section">
            <ListWrapper style={{width:'70%',flexGrow:2}} title ="Tax Return List">
                <ListFilterButtons handleChange={(name,value)=>dispatch(setTaxfileFilter(value))} selected={taxfileFilter} list={taxfileStatus}/>

                <List 
                thead={TaxReturnListThead}
                >
                    <ListBody>

                        {taxFileList?.length>0 ? taxFileList?.map((row,index)=>{
                            return <tr key={index}> 
                                <td>{row?.id}</td>
                                <td>{row?.firstname + ' ' + row?.lastname}</td>
                                <td>{row?.email} <br/>{row?.mobile_number}</td>
                                <td>{row?.marital_status}</td>
                                <td>{row?.province}</td>
                                <td style={{textAlign:''}}><TaxReturnStatus code={row?.file_status} status={row?.file_status_name}/></td>
                                <td style={{textAlign:''}}>{(row?.payment_paid_count && parseInt(row?.payment_paid_count) > 0) ? <TaxReturnStatus code='PAYMENT_DONE' status={'Paid'}/> : ''}</td>
                                {/* <td><Button title={<IoIosEye />} varient="icon" onClick={()=>navigate('/executive/taxfile/'+row?.id)} /></td> */}
                                <td><ListRowActions actions={[
                                    {
                                        icon:'view',
                                        onClick:()=>navigate('/executive/taxfile/'+row?.id)
                                    },
                                    {
                                        icon:'message',
                                        onClick:()=>navigate('/executive/message/'+row?.user_id)
                                    }
                                ]}/></td>
                                {/* <td><IconView onClick={()=>navigate('/executive/taxfile/'+row?.id)}/></td> */}
                            </tr>
                        }) : <p style={{textAlign: 'center', marginTop: '20px'}}>No Record Found</p>}
                        
                    </ListBody>
                </List>
            </ListWrapper>
            <ListWrapper style={{width:'25%',flexGrow:1}}>
                <List 
                thead={MessageListThead}
                title ="New Messages">
                    <ListBody>
                        {clientMessage?.length>0 ? clientMessage?.map((row,index)=>{
                                return <tr key={index} style={{cursor: 'pointer'}} onClick={()=>navigate('/executive/message/'+row?.user_id)}> 
                                <td>{row?.user_email || row?.firstname}</td>
                                <td className="tax-list-msg-count"><p className={`${row?.client_message_count>0 ? 'green': 'grey'}`}><span>{row?.client_message_count}</span></p></td>
                            </tr>
                        }) : <p style={{textAlign: 'center', marginTop: '20px'}}>No Record Found</p>}
                        
                        
                    </ListBody>
                </List>
            </ListWrapper>
        </div>
        
        
    </PanelLayout>
}

export default TaxFileList;



const TaxReturnListThead = [
    {
        title:'id',
        width:'5%'
    },
    {
        title:'Name',
        width:'15%'
    },
    {
        title:'Email',
        width:'15%'
    },
    {
        title:'Marital Status',
        width:'13%'
    },
    {
        title:'Province',
        width:'13%'
    },
    {
        title:'Status',
        width:'14%'
    },
    {
        title:'Has Paid ?',
        width:'10%'
    },
    {
        title:'',
        width:'10%'
    }

];

const MessageListThead = [
    {
        title:'Username',
        width:'90%'
    },
    {
        title:'Messages',
        width:'10%'
    },

];